import { create } from 'zustand';

/**
 * Global "Your Locker" overlay state. The Locker (themes + titles + emblems) is
 * the single surface that changes a user's background theme, so it has to be
 * openable from anywhere — the avatar-menu theme rail and the Settings →
 * Appearance signpost both flip this. Mirrors `authModalStore`: one store, one
 * host mount (`LockerHost` in RootLayout).
 */
interface LockerState {
  open: boolean;
  openLocker: () => void;
  closeLocker: () => void;
}

export const useLocker = create<LockerState>((set) => ({
  open: false,
  openLocker: () => set({ open: true }),
  closeLocker: () => set({ open: false }),
}));
